// composables/boletas/useBoletas.js
import { useStore } from 'vuex'

export const useBoletas = () => {
  const config = useRuntimeConfig();
  const store = useStore();

  const debug = {
    enabled: config.public.modo === 'DEV',
    log(...args) {
      if (this.enabled) console.log("[useBoletas]", ...args);
    },
    error(...args) {
      if (this.enabled) console.error("[useBoletas]", ...args);
    },
  };

  async function crearSesion() {
    const response = await $fetch("/api/boletas/boletas", {
      method: "POST",
      body: { action: "crear-sesion" },
    });

    if (!response?.success || !response.data?.token) {
      throw new Error(response?.message || "No se pudo crear la sesión de boletas.");
    }

    store.commit('boletas/SET_TOKEN', response.data.token);
    debug.log("sesión de boletas creada correctamente");
    return response.data.token;
  }

  function manejarSesionExpirada() {
    store.commit('boletas/RESET_TOKEN');
    store.commit('boletas/SET_SESION_EXPIRADA', true);
  }

  async function llamar(action, params = {}, reintentar = true) {
    let token = store.getters['boletas/getToken'];

    if (!token) {
      token = await crearSesion();
    }

    const response = await $fetch("/api/boletas/boletas", {
      method: "POST",
      body: { action, token, ...params },
    });

    debug.log(`respuesta cruda de "${action}":`, response);

    if (response?.success === false && response?.codigo === 401) {
      if (reintentar) {
        debug.log(`token expirado en "${action}", renovando y reintentando...`);
        store.commit('boletas/RESET_TOKEN');
        await crearSesion();
        return await llamar(action, params, false);
      }

      manejarSesionExpirada();
      return new Promise(() => {});
    }

    if (response?.success === false) {
      throw new Error(response?.message || "Error desconocido");
    }

    return response.data;
  }

  //#region API CALLS
  function buscarBoletaPorFolio(folio, monto) {
    return llamar("buscarporfolio", { folio, monto });
  }

  function buscarBoletasPorPatente(patente, correo, fecha) {
    return llamar("buscarporpatente", { patente, correo, fecha });
  }

  function enviarCodigoOtp(folio, canal) {
    return llamar("enviar-codigo", { folio, canal });
  }

  function validarCodigoOtp(folio, codigo) {
    return llamar("validar-codigo", { folio, codigo });
  }

  function descargarPdfBoleta(folio) {
    return llamar("descargar-pdf", { folio });
  }

  function enviarConsultaBoleta({ folio, motivo, detalle, contacto }) {
    return llamar("enviar-consulta", { folio, motivo, detalle, contacto });
  }

  function validarAccesoRapido(tokenQr) {
    return llamar("validar-acceso-rapido", { token_qr: tokenQr });
  }
  //#endregion

  return {
    crearSesion,
    buscarBoletaPorFolio,
    buscarBoletasPorPatente,
    enviarCodigoOtp,
    validarCodigoOtp,
    descargarPdfBoleta,
    enviarConsultaBoleta,
    validarAccesoRapido,
  };
};